import { SortType } from '../model.module/constant/sort-types.enum';

export class SortFunctions {

    static sortArray4Strings(table: any[], cellName: string, asc: boolean): void {
        const factor = asc ? 1 : -1;

        table.sort((a, b) => {
            const cellValueA = a[cellName];
            const cellValueB = b[cellName];

            const valueA = (typeof cellValueA === 'object' && 'value' in cellValueA) ? cellValueA.value : cellValueA;
            const valueB = (typeof cellValueB === 'object' && 'value' in cellValueB) ? cellValueB.value : cellValueB;

            if (valueA.toLowerCase() > valueB.toLowerCase()) {
                return factor;
            } else if (valueA.toLowerCase() < valueB.toLowerCase()) {
                return -1 * factor;
            }

            return 0;
        });
    }

    static sortArray4Number(table: any[], cellName: string, asc: boolean): void {
        const factor = asc ? 1 : -1;

        table.sort((a, b) => {
            const valueA = a[cellName];
            const valueB = b[cellName];
            return (valueA - valueB) * factor;
        });
    }

    static sortArray4Buergscheine(table: any[], cellName: string, asc: boolean): void {
        const factor = asc ? 1 : -1;
        const tupleA = table[0][cellName].split(/[-\/]/);
        const len = tupleA.length;

        for (let i = len - 1; i >= 0; i--) {
            SortFunctions.doSortArray4Buergscheine(table, cellName, factor, i);
        }
    }

    static sortArray(type: SortType, table: any[], cellName: string, asc: boolean): void {
        switch (type) {
            case SortType.ALPHABETICAL:
                SortFunctions.sortArray4Strings(table, cellName, asc);
                break;
            case SortType.NUMERICAL:
                SortFunctions.sortArray4Number(table, cellName, asc);
                break;
            case SortType.BUERGSCHEIN_NUMBER:
                SortFunctions.sortArray4Buergscheine(table, cellName, asc);
                break;
            default:
                console.debug(`SortType ${type} nicht gefunden`);
        }
    }

    private static doSortArray4Buergscheine(table: any[], cellName: string, factor: number, index: number): void {
        table.sort((a, b) => {
            const tupleA = a[cellName].split(/[-\/]/);
            const tupleB = b[cellName].split(/[-\/]/);
            return (tupleA[index] - tupleB[index]) * factor;
        });
    }
}
